export class CreditCardTerms {
  UserName: string;
  IPAddress: string;
  TermsID: string;
}
